export const PAUSED = "PAUSED"
export const WAITING = "WAITING"
export const INPROCESSING = "INPROCESSING"
export const MISSEDCALL = "MISSEDCALL"
export const MOVING = "MOVING"
export const UPDATED = "UPDATED"
